import { render, staticRenderFns } from "./OujdaFoodDashboardAdmin.vue?vue&type=template&id=03a67fc3&"
import script from "./OujdaFoodDashboardAdmin.vue?vue&type=script&lang=js&"
export * from "./OujdaFoodDashboardAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports